import { render, staticRenderFns } from "./black-vip-zone.vue?vue&type=template&id=50dd858d&scoped=true&"
import script from "./black-vip-zone.vue?vue&type=script&lang=js&"
export * from "./black-vip-zone.vue?vue&type=script&lang=js&"
import style0 from "./black-vip-zone.vue?vue&type=style&index=0&id=50dd858d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd858d",
  null
  
)

export default component.exports